import React from 'react';
import { Link } from 'react-router-dom';
import { GlowingEffect } from './GlowingEffect/GlowingEffect';

/**
 * GeneralPlatform - A reusable component for displaying platform logos with glowing effect
 * 
 * @param {string} name - The name of the platform
 * @param {string} link - The link to navigate to when clicked (pass '#' if using onClick)
 * @param {string} imageSrc - The source of the platform logo image
 * @param {boolean} useGlow - Whether to use the glowing effect (default: true)
 * @param {boolean} isSelected - Whether this platform is selected (for static glow)
 * @param {function} onClick - Optional click handler (if provided, acts as a button instead of link)
 * @param {string} className - Additional CSS classes to apply
 * @param {boolean} interactiveGlow - Whether to use interactive hover glow (default: true)
 */
export function GeneralPlatform({ 
  name, 
  link = "#",
  imageSrc, 
  useGlow = true,
  isSelected = false,
  onClick,
  className = '',
  interactiveGlow = true
}) {
  // Handle click events
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  // Different rendering for normal link vs clickable item
  if (onClick) {
    // Button-like behavior (for Paidads)
    return (
      <div 
        className={`platform-item ${isSelected ? 'selected-platform' : ''} ${className}`}
        onClick={handleClick}
        style={{ 
          cursor: 'pointer',
          textDecoration: 'none',
          color: 'white',
          display: 'block',
          textAlign: 'center'
        }}
      >
        <div className="platform-wrapper">
          <div className="platform-container">
            {useGlow && isSelected && (
              // Simple static glow effect for selected platforms
              <div className="static-glow"></div>
            )}
            <img 
              src={imageSrc} 
              alt={`${name} Logo`} 
              className="platform-logo" 
            />
          </div>
          <p className={isSelected ? 'selected-name' : ''}>{name}</p>
        </div>
      </div>
    );
  } else {
    // Standard link behavior (for Homepage)
    return (
      <Link 
        to={link} 
        className={`platform-link ${className}`}
        style={{ 
          display: 'block', 
          textDecoration: 'none',
          color: 'white'
        }}
      >
        <div className="platform-wrapper">
          <div className="platform-container">
            {useGlow && interactiveGlow && (
              // Interactive glow effect for HomePage hover behavior
              <GlowingEffect
                spread={25}
                glow={true}
                disabled={false}
                proximity={60}
                inactiveZone={0}
                borderWidth={0}
              />
            )}
            <img 
              src={imageSrc} 
              alt={`${name} Logo`} 
              className="platform-logo" 
            />
          </div>
          <p>{name}</p>
        </div>
      </Link>
    );
  }
}
